export interface FieldSchema<T> {
  readonly key: string
  readonly label: string
  readonly value: (r: T) => unknown
  readonly sortValue?: (r: T) => unknown
  readonly searchText?: (r: T) => string
  readonly labelValue?: (r: T) => string | readonly string[]
  readonly bandOrder?: (records: readonly T[]) => string[]
  readonly searchable?: boolean
  readonly facetable?: boolean
  readonly groupable?: boolean
  readonly sortable?: boolean
  /** Label for this field's empty option; falls back to the schema's. */
  readonly emptyOptionLabel?: string
}

export interface ListSchema<T> {
  readonly getId: (r: T) => string
  readonly fields: readonly FieldSchema<T>[]
  readonly bandLevels?: ReadonlyArray<{ readonly fieldKey: string }>
  readonly emptyOptionLabel?: string
}

export interface ResolvedBandLevel<T> {
  readonly fieldKey: string
  readonly field: FieldSchema<T>
}

export function resolveBandLevels<T>(
  schema: ListSchema<T>,
  fieldKeys?: readonly string[],
): readonly ResolvedBandLevel<T>[] {
  const keys =
    fieldKeys ?? schema.bandLevels?.map(level => level.fieldKey) ?? []

  return keys.flatMap(fieldKey => {
    const field = schema.fields.find(candidate => candidate.key === fieldKey)
    if (!field?.groupable) return []
    return [{ fieldKey, field }]
  })
}

export function getField<T>(
  schema: ListSchema<T>,
  fieldKey: string,
): FieldSchema<T> | undefined {
  return schema.fields.find(field => field.key === fieldKey)
}
